import axios from "axios";

var CAR = {};

var sourceIndicatorTableData = [
  {
    label: "Indicators",
    children: [
      {
        label: "INDICATORS",
        field: "indicator",
        filterable: false,
        type: "text",
        html: true,
        index: 0,
        hidden: false,
        sortable: false,
        // width: '330px',
      },
    ],
  },
  {
    label: "Routine",
    children: [
      {
        label: "NHMIS",
        field: "nhmis",
        type: "text",
        html: true,
        filterable: false,
        fullName: "National Health Management Information System",
        hasValue: true,
        index: 1,
        headerField: "'Routine'",
        class: "Routine",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
    ],
  },
  {
    label: "National Surveys",
    children: [
      {
        label: "NDHS",
        field: "ndhs",
        type: "text",
        html: true,
        filterable: false,
        fullName: "National Demographic and Health Survey",
        hasValue: true,
        index: 2,
        class: "N.S",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "MICS",
        field: "mics",
        type: "text",
        html: true,
        fullName: "Multiple Indicator Cluster Survey",
        hasValue: true,
        index: 3,
        class: "N.S",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "NNHS",
        field: "nnhs",
        type: "text",
        html: true,
        filterable: false,
        fullName: "National Nutrition and Health Survey",
        hasValue: true,
        index: 4,
        class: "N.S",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "NMIS",
        field: "nmis",
        type: "text",
        html: true,
        fullName: "Nigeria Malaria Indicator Survey",
        hasValue: true,
        index: 5,
        class: "N.S",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "NARHS",
        field: "narhs",
        type: "text",
        html: true,
        fullName: "National HIV and AIDS and Reproductive Health Survey",
        hasValue: true,
        index: 6,
        class: "N.S",
        hidden: false,
        sortable: false,
        uncertainty: false,
      }
    ],
  },
  {
    label: "Estimates",
    children: [
      {
        label: "WHO-GHO",
        field: "who",
        type: "text",
        html: true,
        fullName: "World Health Organization",
        index: 7,
        class: "O.E",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "World Bank",
        field: "world_bank",
        type: "text",
        html: true,
        fullName: "World Bank",
        hasValue: true,
        index: 8,
        class: "O.E",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "IHME",
        field: "ihme",
        type: "text",
        html: true,
        fullName: "Institute for Health Metrics and Evaluation",
        index: 9,
        gameL: 1,
        hasValue: true,
        class: "O.E",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      {
        label: "WUENIC",
        field: "wuenic",
        type: "text",
        html: true,
        fullName: "WHO and UNICEF estimates",
        index: 10,
        hasValue: true,
        class: "O.E",
        hidden: false,
        sortable: false,
        uncertainty: false,
      },
      // {
      //   label: 'COUNTRY',
      //   field: 'country',
      //   type: 'text',
      //   html:true,
      //   fullName: 'WUENIC reported Country Estimate',
      //   index: 11,
      //   hasValue: true,
      //   class: 'O.E',
      //   hidden: false,
      //   sortable: false
      // },
      // {
      //   label: 'ADM EST',
      //   field: 'adm_est',
      //   type: 'text',
      //   html:true,
      //   fullName: 'WUENIC reported Country Estimate',
      //   index: 12,
      //   hasValue: true,
      //   class: 'O.E',
      //   hidden: false,
      //   sortable: false
      // }
    ],
  },
];
let faqs = [
  {
    title: "What is the platform about?",
    ans: "The Multi-Source Data Analytics and Triangulation (MSDAT) Platform, developed by the Federal Ministry of Health (FMoH) Nigeria provides a single transparent view of key health indicators from multiple data sources. Recognizing that data quality, trends and interpretation depend on the data source and methodology, the platform offers comparisons of key metrics across three categories of data sources, namely; routine, surveys, and global estimates.",
    show: false,
  },
  {
    title:
      "What are some future plans for the platform? (e.g. interoperability and APIs, data projections, state profile platforms, etc.)",
    ans: "The MSDAT platform will capture data from all geographical disaggregations (National, geopolitical zones, state, senatorial district, LGAs and health facilities) across the country. The platform will accommodate more indicators from more program areas, development of a mobile application, data projections and state profile platforms.",
    show: false,
  },
  {
    title: "Who owns the MSDAT Platform?",
    ans: "The MSDAT platform is owned by the Federal Ministry of Health (FMoH)",
    show: false,
  },
  {
    title: "Where is the data for the platform obtained from? And how?",
    ans: "Data from MSDAT is obtained from the National Health Management Information System (NHMIS), from Survey reports, and Global estimates. Data is extracted, cleaned and reviewed before it is used on the platform.",
    show: false,
  },
  {
    title:
      "What are the levels of data aggregation found on the platform? (i.e. is state, LGA, community/facility-level data available?)",
    ans: "National, zonal, state and LGA data are available on the platform",
    show: false,
  },
  {
    title: "What program areas are available?",
    ans: `The program areas currently available on the platform are:
                <ul>
                  <li>Reproductive, Maternal, Newborn and Child Health</li>
               <li>Mortality</li>
                <li>Immunization</li>
                <li>Malaria</li>
                 <li>HIV</li>
                  <li>Nutrition</li>
                </ul>
            In case there are other program areas you would like to see, you can send an email to: <a href="https://msdatfeedback@e4email.net">msdatfeedback@e4email.net</a>`,
    show: false,
  },
  {
    title:
      "Is there a plan to include more indicators and data sources on the MSDAT Platform?",
    ans: `The platform is scalable to accommodate more indicators and data sources. About 200 new indicators will be available on the platform by the end of 2020. However, the addition of new indicators to the platform is subject to approval from the DHPRS-FMoH. If there are new indicators you would like to be added, we can be contacted here: <a href="https://msdatfeedback@e4email.net">msdatfeedback@e4email.net</a>`,
    show: false,
  },
  {
    title:
      "What criteria are used in selecting which indicators and data sources appear on the platform? Who does the selection and how long does the approval process take?",
    ans: "A set of criteria has been developed and approved by the DHPRS-FMoH. All potential data sources and indicators are screened using these criteria and are subject to review sessions by select health stakeholders.",
    show: false,
  },
  {
    title: "How can I submit a data source to be included on MSDAT?",
    ans: `There is a “Submit new dataset” icon on the MSDAT platform. This is the link: <a href="https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/">https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/</a>. Please click on it and follow the prompts.`,
    show: false,
  },
  {
    title: "Can I download or request for the raw data on the platform?",
    ans: "Yes. datasets for all the visualizations are available in downloadable formats.",
    show: false,
  },
  {
    title:
      "Can the MSDAT platform triangulate data across data sources with differing methodologies?",
    ans: "Not at this time, but it provides information about the methodology from each data source about an indicator that could be used to triangulate the available data.",
    show: false,
  },
  {
    title: "How is the platform currently being used?",
    ans: "It is currently being used for health data analytics and development of state health profiles. Researchers are also able to get access to needed data on health outcomes of interest.",
    show: false,
  },
  {
    title:
      "How often is the data on the MSDAT platform updated? Is the data real-time?",
    ans: "No. The data is not real-time. The platform is reviewed monthly and if data sources are available, the corresponding changes are made to the platform.",
    show: false,
  },
  {
    title:
      "What checks are in place to ensure that data is accurate and up to date?",
    ans: "The data undergoes a six-sigma methodology with the aim of ensuring data accuracy on the platform on a monthly basis. Data is sourced only from government-approved bodies.",
    show: false,
  },
  {
    title: "Is monthly data available on the MSDAT Platform?",
    ans: "Not yet. Processes are in motion to include that in upcoming versions of the platform",
    show: false,
  },
  {
    title: "Does the platform work offline?",
    ans: "Yes. Once the platform has been fully loaded once, it will always be available for viewing on the browser. It can also be installed on the desktop of the user for quick access.",
    show: false,
  },
  {
    title:
      "What can I do if I cannot find data on indicators specific to my program area?",
    ans: `The platform is continually growing, and new indicators will be added. We can notify you when indicators specific to your program areas have been added. You can fill in your contact details in this form <a href="msdat.fmohconnect.gov.ng/#/contact">msdat.fmohconnect.gov.ng/#/contact</a>`,
    show: false,
  },
  {
    title: "Whom can I contact for feedback concerning the platform?",
    ans: `You can send an email to <a href="mailto:msdatfeedback@e4email.net">msdatfeedback@e4email.net</a> or you can follow this <a href="">link</a> and fill in the form.`,
    show: false,
  },
];
var dashboardHelp = [
  {
    title: "How to Change Selected indicator",
    steps: {
      First_Method: [
        "Click on the dropdown arrow next to the main indicator.",
        "Scroll down  to the appropriate program area where the desired indicator can be found.",
        "Click on the program dropdown.",
        "You can also type keywords of the desired indicator into the search field.",
        "When found, click on the desired indicator.",
      ],
      Second_Method: [
        "Go to the indicator search field at the top of the platform.",
        "Scroll down to the appropriate program area where the desired indicator can be found.",
        "Click on the program dropdown.",
        "You can also type keywords of the desired indicator into the search field.",
        "When found, click on the desired indicator.",
      ],
    },
    show: false,
  },
  {
    title: "How to change related indicator",
    steps: [
      "Click on the dropdown arrow next to the related indicator you want to change.",
      "Scroll down to the appropriate program area where the desired indicator can be found.",
      "Click on the program dropdown.",
      "You can also type keywords of the desired indicator into the search field.",
      "When found, click on the desired indicator.",
    ],
    show: false,
  },
  {
    title: "How to check for more information on the indicator",
    steps: [
      "Select the indicator you want to see more information on.",
      // 'On the table, click on the <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: black;"></i> to the left of the indicator.',
      'On the table, click on the info icon <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: #41918E; font-size: 15px;"></i> to the left of the indicator.',
      "Information on the indicator is given with respect to the data source, therefore, you can switch between the available data sources.",
      "You can also get more information on the indicator by going to the Information Page.",
    ],
    show: false,
  },
  {
    title: "How to check information on the Data Source",
    steps: [
      // 'On the table, click on the <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: black;"></i> by the data source you are interested in.',
      'On the table, click on the info icon <i data-v-862f69e2 class="fas fa icon fa-info-circle" style="color: #41918E; font-size: 15px;"></i> by the data source you are interested in.',
      "You can also get more information on the data sources by going to the information page.",
    ],
    show: false,
  },
  {
    title: "How to change the dataset showing on all the charts",
    steps: ["Click on the desired dataset on the table."],
    show: false,
  },
  {
    title: "How to change the period showing on the Bar chart",
    steps: [
      "Click in the period filter found over the bar chart.",
      "There would be a drop down showing only periods with available data.",
      "Click on the desired period.",
    ],
    show: false,
  },
  {
    title:
      "How to change Location of the data showing on the indicator table and data trend (Line chart) chart",
    steps: [
      "Click on the Location filter found at the top right of the platform.",
      "Search and select the desired location.",
      "Data for the selected location will reflect on the Indicator table and line chart.",
    ],
    show: false,
  },
  {
    title: "How to change data set showing on the Zonal chart",
    steps: [
      "Select the Dataset filter just above the zonal chart.",
      "Click on the dataset you want to see.",
      "The selected dataset will show on both the zonal chart and map.",
    ],
    show: false,
  },
  {
    title: "How to change the period on the zonal chart",
    steps: [
      "Click on the period filter just above the zonal chart.",
      "Select the desired period.",
    ],
    show: false,
  },
  {
    title:
      "How to compare multiple datasets for an indicator across the states",
    steps: [
      "Go to the multi-dataset comparison panel.",
      "Select the indicator you want to compare from the indicator filter just above the panel.",
      "Select the data sets you want to compare from the filter above the panel.",
      "You can select up to four datasets.",
    ],
    show: false,
  },
  {
    title: "How to compare different indicators from the same data sets",
    steps: [
      "Open the “Compare Indicators” Panel.",
      "Select the data set you want to compare indicators from on the the filter just above the panel.",
      "Select the indicators you want to compare on the individual charts.",
      "You can change chart types: bar chart, column chart, a zonal chart and a states map for each chart.",
    ],
    show: false,
  },
  {
    title: "How to download the data from a chart",
    steps: [
      "Click on the download button on each chart.",
      "Select either download as csv or download as xls.",
    ],
    show: false,
  },
  {
    title: "How to download the chart as an image",
    steps: [
      "Click on the download button on each chart.",
      "Select the picture type you want to download the chart as: png, jpeg, pdf, vector image.",
    ],
    show: false,
  },
  {
    title: "How to view information on the National target",
    steps: ["Click on the target line."],
    show: false,
  },
  {
    title: "How to check the confidence range.",
    steps: [
      "On the table, find the data set you want to check the confidence range for.",
      "If the confidence range is available, there would be a toggle under the data set on the table.",
      "Toggle the switch to view the confidence range.",
    ],
    show: false,
  },
];

var columns = [
  {
    label: "INDICATORS",
    field: "indicator",
    filterable: false,
    type: "string",
    html: true,
    index: 0,
    hidden: false,
    width: "330px",
  },
  {
    label: "NHMIS",
    field: "nhmis",
    type: "string",
    html: true,
    filterable: false,
    fullName: "National Health Management Information System",
    hasValue: true,
    index: 1,
    headerField: "'Routine'",
    class: "Routine",
    hidden: false,
  },
  {
    label: "NDHS",
    field: "ndhs",
    type: "string",
    html: true,
    filterable: false,
    fullName: "National Demographic and Health Survey",
    hasValue: true,
    index: 2,
    class: "N.S",
    hidden: false,
  },
  {
    label: "MICS",
    field: "mics",
    type: "string",
    html: true,
    fullName: "Multiple Indicator Cluster Survey",
    hasValue: true,
    index: 3,
    class: "N.S",
    hidden: false,
  },
  {
    label: "NNHS",
    field: "nnhs",
    type: "string",
    html: true,
    filterable: false,
    fullName: "National Nutrition and Health Survey",
    hasValue: true,
    index: 4,
    class: "N.S",
    hidden: false,
  },
  {
    label: "NMIS",
    field: "nmis",
    type: "string",
    html: true,
    fullName: "Nigeria Malaria Indicator Survey",
    hasValue: true,
    index: 5,
    class: "N.S",
    hidden: false,
  },
  {
    label: "NARHS",
    field: "narhs",
    type: "string",
    html: true,
    fullName: "National HIV and AIDS and Reproductive Health Survey",
    hasValue: true,
    index: 6,
    class: "N.S",
    hidden: false,
  },
  {
    label: "WHO-GHO",
    field: "who",
    type: "string",
    html: true,
    fullName: "World Health Organization",
    index: 7,
    class: "O.E",
    hidden: false,
  },
  {
    label: "World Bank",
    field: "world_bank",
    type: "string",
    html: true,
    fullName: "World Bank",
    hasValue: true,
    index: 8,
    class: "O.E",
    hidden: false,
  },
  {
    label: "IHME",
    field: "ihme",
    type: "string",
    html: true,
    fullName: "Institute for Health Metrics and Evaluation",
    index: 9,
    gameL: 1,
    hasValue: true,
    class: "O.E",
    hidden: false,
  },
  {
    label: "WUENIC",
    field: "wuenic",
    type: "string",
    html: true,
    fullName: "WHO and UNICEF estimates",
    index: 10,
    hasValue: true,
    class: "O.E",
    hidden: false,
  },
  // {
  //   label: 'COUNTRY',
  //   field: 'country',
  //   type: 'string',
  //   html:true,
  //   fullName: 'WUENIC reported Country Estimate',
  //   index: 11,
  //   hasValue: true,
  //   class: 'O.E',
  //   hidden: false
  // },
  // {
  //   label: 'ADM EST',
  //   field: 'adm_est',
  //   type: 'string',
  //   html:true,
  //   fullName: 'WUENIC reported Country Estimate',
  //   index: 12,
  //   hasValue: true,
  //   class: 'O.E',
  //   hidden: false
  // }
];

var dataSourceDescriptions = {
  MICS: `Multiple Indicator Cluster Survey 2016-2017: The fifth MICS which is an international household survey developed by UNICEF involving the collection of data on a wide range of indicators on the situation of children and women. Target groups: Women and men aged 15-49 years; Children less than 5 years.  Number of sampled households: 33,901. See more: <a target="_blank" href="https://mapping.fmohconnect.gov.ng/dataset/multiple-indicator-cluster-survey-2016-2017/">https://mapping.fmohconnect.gov.ng/dataset/multiple-indicator-cluster-survey-2016-2017/</a>`,
  NDHS: `Demographic and Health Survey 2013: A national sample survey that provides up-to-date information on background characteristics of the respondents. Target groups: Women and men aged 15-49 years. Number of sampled households: 38,522. See more: <a target="_blank" target="_blank" href="https://mapping.fmohconnect.gov.ng/dataset/nigeria-demographic-health-survey-2013/">https://mapping.fmohconnect.gov.ng/dataset/nigeria-demographic-health-survey-2013/</a>`,
  NARHS: `National HIV and AIDS and Reproductive Health Survey 2012: The 2012 National HIV and AIDS and Reproductive Health Survey (NARHS Plus II) was a nationally representative survey carried out to provide information on key HIV & AIDS and reproductive health knowledge and behavior related issues. Target groups: Females aged between 15 and 49 years and males aged 15 to 64 years. Number of sampled households sampled: 32,543.`,
  NMIS: `Nigeria Malaria Indicator Survey 2015: A follow-up survey to the 2010 NMIS baseline survey with the primary objectives of providing information on malaria indicators and malaria prevalence at the national level and also in each of the 36 states of the country and the Federal Capital Territory. Target groups: Number of sampled households: 37,674. See more: <a target="_blank" href="https://mapping.fmohconnect.gov.ng/dataset/nigeria-malaria-indicator-survey-2015/">https://mapping.fmohconnect.gov.ng/dataset/nigeria-malaria-indicator-survey-2015/</a>`,
  NNHS: `National Nutrition and Health Survey 2015: The second national survey conducted in all 36 states of Nigeria and Federal Capital Territory (FCT) to assess the nutritional and health status of women and children. In order to provide reliable data for planning and monitoring of key activities, new key indicators on Malaria and Antenatal care. Target groups: Children under 5 years and women aged 15 to 49. Number of households sampled: 25,210.`,
  NHMIS: `National Health Management Information System: Nigeria has adopted the DHIS2 as the National tool for the reporting of routine health-related data. This data is reported and aggregated monthly using this platform`,
  "World Bank": `Health Nutrition and Statistics data obtained from World Bank open data catalog. It contains key health, nutrition and population statistics gathered from a variety of international sources`,
  IHME: "Institute for Health Metrics and Evaluation",
  "WHO-GHO": "World Health Organization",
  WUENIC: `Data is jointy produced from WHO and UNICEF. Estimates are country specific and obtained from the review of reports regarding national immunization coverage, finalized survey reports and data from published and grey literature. See more: <a target="_blank" target="_blank" href="http://www.who.int/immunization/monitoring_surveillance/routine/coverage/en/index4.html">http://www.who.int/immunization/monitoring_surveillance/routine/coverage/en/index4.html</a>`,
};

var targetGroups = {
  MICS: `Women and men aged 15-49 years; Children less than 5 years`,
  NDHS: `Women and men aged 15-49 years`,
  NARHS: `Females aged between 15 and 49 years and males aged 15 to 64 years`,
  NMIS: `Women and men aged 15-49 years; Children less than 5 years`,
  NNHS: `Children under 5 years and women aged 15 to 49`,
  NHMIS: ``,
  "World Bank": ``,
  IHME: ``,
  // "IHME-SDG":``,
  "WHO-GHO": ``,
  // COUNTRY: ``,
  WUENIC: ``,
  // "ADM EST": ``
};

var sampledHouseHold = {
  MICS: 33901,
  NDHS: 38522,
  NARHS: 32543,
  NMIS: 37674,
  NNHS: 25210,
  NHMIS: ``,
  "World Bank": ``,
  IHME: ``,
  // "IHME-SDG":``,
  "WHO-GHO": ``,
  // COUNTRY: ``,
  WUENIC: ``,
  // "ADM EST": ``
};

var stateNameLookUpTable = {
  Abia: "in Abia",
  Adamawa: "in Adamawa",
  "Akwa Ibom": "in Akwa Ibom",
  Anambra: "in Anambra",
  Bauchi: "in Bauchi",
  Bayelsa: "in Bayelsa",
  Benue: "in Benue",
  Borno: "in Borno",
  "Cross River": "in Cross River",
  Delta: "in Delta",
  Ebonyi: "in Ebonyi",
  Edo: "in Edo",
  Ekiti: "in Ekiti",
  Enugu: "in Enugu",
  FCT: "in FCT",
  Gombe: "in Gombe",
  Imo: "in Imo",
  Jigawa: "in Jigawa",
  Kaduna: "in Kaduna",
  Kano: "in Kano",
  Katsina: "in Katsina",
  Kebbi: "in Kebbi",
  Kogi: "in Kogi",
  Kwara: "in Kwara",
  Lagos: "in Lagos",
  Nasarawa: "in Nasarawa",
  National: "across the country",
  Niger: "in Niger",
  Ogun: "in Ogun",
  Ondo: "in Ondo",
  Osun: "in Osun",
  Oyo: "in Oyo",
  Plateau: "in Plateau",
  Rivers: "in Rivers",
  Sokoto: "in Sokoto",
  Taraba: "in Taraba",
  Yobe: "in Yobe",
  Zamfara: "in Zamfara",
  "North-East": "in North-East Nigeria",
  "North-West": "in North-West Nigeria",
  "North-Central": "in North-Central Nigeria",
  "South-East": "in South-East Nigeria",
  "South-West": "in South-West Nigeria",
  "South-South": "in South-South Nigeria",
};

var estimatesIndicatorOptions = [
  // {name: "Adolescent fertility rate"},
  { name: "Adolescent birth rate" },
  { name: "Maternal Mortality Ratio" },
  { name: "Neonatal mortality rate (per 1000 live births)" },
  {
    name: "Percentage of children fully immunized against childhood diseases by age 1",
  },
  // {name:"Prevalence of stunting among under 5 childen"},
  { name: "Prevalence of stunting among under 5 children" },
  { name: "Prevalence of wasting among children under 5" },
  { name: "Skilled attendance at delivery or birth" },
  { name: "Under 5 Mortality rate" },
];

var optionStates2 = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "National",
  "Niger",
  "Nigeria",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

var optionStates = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Benue",
  "Borno",
  "Bayelsa",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "National",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
  "North-East",
  "North-West",
  "North-Central",
  "South-East",
  "South-West",
  "South-South",
];

var shortIndicatorNames = {
  "Skilled attendance at delivery or birth":
    "Skilled attendance at delivery or birth",
};
var indicatorsAndRelative = {
  "Skilled attendance at delivery or birth": [
    "Maternal Mortality Ratio",
    "ANC Coverage (4 visits)",
  ],
};
var programAreasToIndicators = {
  RMNCH: [
    "Skilled attendance at delivery or birth",
    "ANC Coverage (at least 1 visit)",
    "ANC Coverage (4 visits)",
    "Contraceptive prevalence rate",
    "Adolescent birth rate",
    "Total fertility rate",
    "Unmet need for family planning",
    "Prevalence of Symptoms of Acute Respiratory Infection among under five children",
    "Percentage of children with diarrhoea who received treatment",
    "Prevalence of Diarrhoea",
    "Postnatal care coverage (mother)",
    "Proportion of children under 5 with ARI who received antibiotics",
  ],
};
var indicatorAttributesOtherSources = {
  "Skilled attendance at delivery or birth": [["G", "R"], "P"],
};

CAR.state = {
  // ndDataStore: [],
  lsData: [],
  // apiUrl: "https://nphcda-daily-reporting.firebaseio.com/progAreaSheet.json",
  name: "CAR Platform",
  tableColumnHeaderIndex: null,
  tableColumnHeaderName: null,
  fullscreen: false,
  columns,
  carSources: [
    "MICS",
    "NHMIS",
    "NNHS",
    "NDHS",
    "NMIS",
    "NARHS",
    "IBBS",
    "World Bank",
    "IHME",
    "WHO-GHO",
    "HFS",
    "COUNTRY",
    "WUENIC",
    "ADM EST",
  ],
  indicators: [],
  indicatorsAndRelative,
  programAreasToIndicators,
  estimatesIndicatorOptions,
  optionStates2,
  optionStates,
  // indicatorsAndProgramAreas: {},
  // indicatorAttributes,
  indicatorLength: "32",
  sourceMetaData: "17",
  lastUpdated: "Loading...",
  indicatorSelected: "",
  indicatorAttributesOtherSources,
  selectedIndicator: "Skilled attendance at delivery or birth",
  selectedState: "National",
  lsDataDHIS2: [],
  lsDataMultipleSources: [],
  lsTargetData: [],
  lsLgaData: [],
  lsCARdata: [],
  lsMetaData: [],
  storeMetaData: [],
  ndStateData: [],
  // progAreaData: [],
  shortIndicatorNames,
  stateNameLookUpTable,
  stateSelectedIndicatorSource: {},
  dataSourceDescriptions,
  targetGroups,
  dashboardHelp,
  faqs,
  sampledHouseHold,
  sourceIndicatorTableData,
  defaultSource: null,
  currentCARTableColumns: [],
  ngMapData: {},
  estimateDataMultipleSources: null,
  shareCounter: 0,
  zonalChartCounter: 0,
  reloadDataState: false,
  tableSourceSelected: "",
  params: {},

  compareSection: {
    state: "National",
    relatedIndicators: [],
  },
  NhmisMonthlyData: JSON.parse(localStorage.getItem("nhmis_monthly")),
};

CAR.actions = {
  // storeNdData: ({commit}, data) => {
  // commit('setData', {list: data})
  // },
  storeCARData: ({ commit }, data) => {
    commit("setData", { list: data });
  },
  storeSourceClicked: ({ commit }, data) => {
    commit("setSourceClicked", { list: data });
  },
  storeHeaderIndex: ({ commit }, data) => {
    commit("setHeaderIndex", { list: data });
  },
  storeDefaultSource: ({ commit }, data) => {
    commit("setDefaultSource", { list: data });
  },
  storeInitIndicatorSource: ({ commit }, data) => {
    commit("setInitIndicatorSource", { list: data });
  },
  storeEstimateSourceData: ({ commit }, data) => {
    commit("setEstimateSourceData", { list: data });
  },
  storeIndicatorSelected: ({ commit }, data) => {
    commit("setIndicatorSelected", { list: data });
  },
  storeIndicators: ({ commit }, data) => {
    commit("setIndicators", { list: data });
  },
  storeMultipleSourceData: ({ commit }, data) => {
    commit("setMultipleSourceData", { list: data });
  },
  storeTargetData: ({ commit }, data) => {
    commit("setTargetData", { list: data });
  },
  storeLgaData: ({ commit }, data) => {
    commit("setLgaData", { list: data });
  },
  storeCARData: ({ commit }, data) => {
    commit("setCARdata", { list: data });
  },
  storeMetaData: ({ commit }, data) => {
    commit("setMetaData", { list: data });
  },
  storeIndicatorMetaData: ({ commit }, data) => {
    commit("setIndicatorMetaData", data);
  },
  storeSelectedIndicator: ({ commit }, data) => {
    commit("setSelectedIndicator", data);
  },
  storeNdStateData: ({ commit }, data) => {
    commit("setNdStateData", data);
  },
  storeSelectedState: ({ commit }, data) => {
    commit("setSelectedState", data);
  },
  indicatorsAndProgramAreas: ({ commit }, data) => {
    commit("setIndicatorsAndProgramAreas", data);
  },
  indicatorLength: ({ commit }, data) => {
    commit("setIndicatorLength", data);
  },
  lastUpdated: ({ commit }, data) => {
    commit("setLastUpdated", data);
  },
  sourceLength: ({ commit }, data) => {
    commit("setSourceMetaData", data);
  },
  indicatorAttributes: ({ commit }, data) => {
    commit("setIndicatorAttributes", data);
  },
  indicatorShortNames: ({ commit }, data) => {
    commit("setIndicatorShortNames", data);
  },
  indicatorsRelative: ({ commit }, data) => {
    commit("setIndicatorsRelative", data);
  },
  setOptionState: ({ commit }, data) => {
    commit("setOptionState", data);
  },
  storeMapData: ({ commit }, ngMapData) => {
    commit("setMapData", ngMapData);
  },
  storeShareCounter({ commit }) {
    commit("setShareCounter");
  },
  reloadData({ commit }) {
    commit("setReloadData");
  },
  goToZonalChart({ commit }, data) {
    commit("setZonalChartCounter", data);
  },
  fullscreen({ commit }, data) {
    commit("setFullscreen", data);
  },
  setParams({ commit }, data) {
    commit("setParams", data);
  },
};
// console.log(CAR.state.sourceIndicatorTableData);

CAR.mutations = {
  // setData: (state, {list}) => {
  //   state.ndDataStore = list
  // },
  setData: (state, { list }) => {
    state.lsData = list;
  },
  setSourceClicked: (state, { list }) => {
    state.tableSourceSelected = list;
  },
  setShareCounter: (state) => {
    state.shareCounter++;
  },
  setZonalChartCounter: (state, option) => {
    state.zonalChartCounter = option;
  },
  setFullscreen: (state, val) => {
    state.fullscreen = val;
  },
  setReloadData: (state) => {
    state.reloadDataState = true;
  },
  setIndicatorSelected: (state, data) => {
    state.indicatorSelected = data;
  },
  setHeaderIndex: (state, { list }) => {
    state.tableColumnHeaderName = list.list[2];
    state.currentCARTableColumns = list.list[4];
    // console.log(list.list)
    if (list.list[2] === "INDICATORS") {
      // on refresh make default value selected source.
      state.tableColumnHeaderName = list.list[3]; //'NHMIS' default source;
    }
    state.stateSelectedIndicatorSource = list.stateSelectedIndicatorSource;
    state.tableColumnHeaderIndex = list.list[1];
  },
  setDefaultSource: (state, { list }) => {
    state.defaultSource = list.list;
  },
  setInitIndicatorSource: (state, { list }) => {
    state.stateSelectedIndicatorSource = list.stateSelectedIndicatorSource;
  },
  setIndicators: (state, { list }) => {
    state.indicators = list;
  },
  setEstimateSourceData: (state, { list }) => {
    state.estimateDataMultipleSources = list.list;
  },
  setMultipleSourceData: (state, { list }) => {
    state.lsDataMultipleSources = list.list;
  },
  setTargetData: (state, { list }) => {
    state.lsTargetData = list.list;
  },
  setLgaData: (state, { list }) => {
    state.lsLgaData = list.list;
  },
  setCARdata: (state, { list }) => {
    state.lsCARdata = list.list;
  },
  setIndicatorMetaData: (state, metaData) => {
    state.storeMetaData = metaData;
  },
  setNdStateData: (state, list) => {
    state.ndStateData = list.list;
  },
  setMetaData: (state, { list }) => {
    state.lsMetaData = list.list;
  },
  setSelectedIndicator(state, indicator) {
    state.selectedIndicator = indicator;
  },
  setSelectedState(state, stateVal) {
    state.selectedState = stateVal;
  },
  setIndicatorsAndProgramAreas(state, obj) {
    // console.log(obj);

    state.programAreasToIndicators = obj;
    // state.indicatorsAndProgramAreas = obj
  },
  setIndicatorLength(state, val) {
    state.indicatorLength = val;
  },
  setLastUpdated(state, val) {
    let date1 = new Date(val);
    date1 = date1.toString();
    let date = date1.split(" ");

    let fullDate = date[2] + "-" + date[1] + "-" + date[3];
    state.lastUpdated = fullDate;
  },
  setSourceMetaData(state, val) {
    state.sourceMetaData = val;
  },
  setIndicatorShortNames(state, obj) {
    state.shortIndicatorNames = obj;
  },
  setIndicatorsRelative(state, obj) {
    state.indicatorsAndRelative = obj;
  },
  setIndicatorAttributes(state, obj) {
    state.indicatorAttributesOtherSources = obj;
  },
  setOptionState(state, obj) {
    state.optionStates = obj.data;
  },
  setMapData(state, ngMapData) {
    state.ngMapData = ngMapData.ngMapData;
  },
  setsourceIndicatorTableData(state, columns) {
    state.sourceIndicatorTableData = columns;
  },
  setParams(state, payload) {
    state.params = payload;
  },
};
CAR.getters = {
  getRelatedIndicators(state) {
    return state.compareSection.relatedIndicators;
  },
  getShareCounter(state) {
    return state.shareCounter;
  },
  getZonalChartCounter(state) {
    return state.zonalChartCounter; //Accessed by mapGetters on MainCarDashboard.vue
  },
  getReloadDataState(state) {
    return state.reloadDataState;
  },
  getIndicatorSelected(state) {
    return state.indicatorSelected;
  },
  getSourceClicked(state) {
    // return the exact source clicked and all the table source
    return [state.tableColumnHeaderName, state.tableColumnHeaderIndex].slice(0);
  },
  getTableSourceClicked(state) {
    return state.tableSourceSelected;
  },
  getCarSources(state) {
    return state.carSources.slice(0);
  },
  getSelectedIndicator(state) {
    return state.selectedIndicator;
  },
  getSelectedIndicatorSource(state) {
    return state.stateSelectedIndicatorSource;
  },
  getSelectedState(state) {
    return state.selectedState;
  },
  getNdStateData(state) {
    return state.ndStateData;
  },
  getStoreMetaData(state) {
    return state.storeMetaData;
  },
  getTargetData(state) {
    return state.lsTargetData;
  },
  getLgaData(state) {
    return state.lsLgaData;
  },
  // getIndicatorsAndProgramAreas(state){
  //   console.log(state.programAreasToIndicators);

  //   // return state.indicatorsAndProgramAreas
  //   return state.programAreasToIndicators
  // },
  getIndicators(state) {
    var firstRow = state.lsDataMultipleSources[0];
    var headerObj = {};
    var temp = [];
    firstRow.map((elem, index) => {
      if (index > 1) {
        temp = elem.split("->");
        if (!headerObj[temp[0].trim()]) {
          headerObj[temp[0].trim()] = [];
        }
        headerObj[temp[0].trim()].push(temp[1].trim());
      }
    });
    return headerObj;
  },
  getIndicatorsAndRelative: (state) => (indicator) => {
    return state.indicatorsAndRelative[indicator]
      ? state.indicatorsAndRelative[indicator].slice(0)
      : [];
  },
  getCurrentIndicatorsValue(state) {
    var tableData = state.lsDataMultipleSources.slice(0);
    var indicatorAndSourceValueByState = {};
    state.optionStates.map((elem, index) => {
      indicatorAndSourceValueByState[elem] = [];
    });
    // get the values of the indicators by state by year
    // Abia: [[2011, 91.5, ...], [2012, ...]]
    tableData.map((elem, index) => {
      if (index > 0) {
        var stateName = elem[1];
        var rowDataWithoutState = elem.slice(0);
        rowDataWithoutState.splice(1, 1); // remove the state name
        indicatorAndSourceValueByState[stateName].push(rowDataWithoutState);
      }
    });
    return indicatorAndSourceValueByState;
  },
  // (state) => (id) =>
  getStateIndicatorsValueLatestYear: (state) => (values) => {
    var tableRow = state.lsDataMultipleSources[0].slice(0);
    tableRow.splice(1, 1); // remove org. unit.

    var indicatorYearValue = {};
    tableRow.map((elem, index) => {
      if (index > 0) {
        for (var i = values.length - 1; i >= 0; i--) {
          // if(elem.split('-')[1].trim() === 'NHMIS') { // we don't need NHMIS data here
          //     continue;
          // }
          indicatorYearValue[elem] = [];
          var yearRow = values[i];
          var currentIndicatorVal = yearRow[index];
          if (currentIndicatorVal) {
            indicatorYearValue[elem].push(yearRow[0], currentIndicatorVal);
            break;
          }
        }
      }
    });
    // alert(indicatorYearValue["Percentage of children fully immunized against childhood diseases by age 1 - NHMIS"])
    return indicatorYearValue;
  },
  getDataToRender: (state) => (values, source, selectedIndicator) => {
    var indicatorSourceToReturn = {};
    var programAreaIndicators = selectedIndicator;
    for (var value in values) {
      if (values.hasOwnProperty(value)) {
        var indicatorSource = value.split("-");
        var iSource = indicatorSource[1].trim();
        var indicator = indicatorSource[0].trim();
        if (iSource === source && indicator === selectedIndicator) {
          indicatorSourceToReturn[value] = values[value];
        }
      }
    }
    // console.log(values, indicatorSourceToReturn);
    return indicatorSourceToReturn;
  },
  getShortIndicatorNames: (state) => (indicatorName, columnHeaders) => {
    if (columnHeaders) {
      state.tableColumnHeaderName = columnHeaders[0];
    }
    return state.shortIndicatorNames[indicatorName];
  },
  // not called from component yet
  // async progAreaData(state) {
  //     return await axios.get(state.apiUrl);
  // },
  getOtherDatasetYear(state) {
    var tableData = state.lsDataMultipleSources.slice(0);
    var obj = {};
    tableData.map((elem, index) => {
      if (index > 0) {
        if (!obj[elem[0]]) {
          obj[elem[0]] = [];
        }
        obj[elem[0]].push(elem);
      }
    });
    return Object.keys(obj);
  },
  getDataSourceDescriptions: (state) => (param) => {
    return state.dataSourceDescriptions[param];
  },
  getTargetGroups: (state) => (param) => {
    return state.targetGroups[param];
  },
  getSampledHouseholdData: (state) => (param) => {
    return state.sampledHouseHold[param];
  },
  getDefaultSource(state) {
    return state.defaultSource;
  },
  getCARngMapData(state) {
    //console.log('from store: ',state.ngMapData);
    return state.ngMapData;
  },
  getSourceIndicatorTableData(state) {
    return state.sourceIndicatorTableData.slice(0); // Object.assign([], state.sourceIndicatorTableData);
  },
  getParams(state) {
    return state.params;
  },
};
export default CAR;



// WEBPACK FOOTER //
// ./src/store/modules/car.js